export const SHOP_ABILITY_ALIAS = "shop";
export const SHOP_STATUS_STORE_ID = "general-shop-status";
export const LANDING_PAGE_REDIRECT = "/shop-login-landing";
export const SHOP_LIGHT_CART_ALIAS = "shop-light-cart";
/** Dev-only debug page (QIT-7076) — see shop-debug-page.vue. */
export const SHOP_DEBUG_ALIAS = "shop-debug";
/** Fake login page reached from shop-debug-page.vue — see shop-debug-fake-login-page.vue. */
export const SHOP_DEBUG_LOGIN_ALIAS = "shop-debug-login";
